<ng-container *ngIf="items && items.length">
  <mb-slider-base
    *ngIf="shouldRender; else placeholdertpl"
    [itemsToSlide]="3"
    [itemsToShow]="3"
    [items]="items"
    [config]="config"
    containerClass="container-sm"
    #slider
    (indexChanged)="indexChanged.emit($event)"
  >
    <ng-template #itemTemplate let-item="item" let-index="index">
      <ng-container *ngIf="item.link; else cardTemplate">
        <ng-container [ngSwitch]="item.link.type">
          <a *ngSwitchCase="linkTypes.ROUTER" draggable="false" class="card-container" [routerLink]="item.link.url">
            <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
          </a>
          <a
            *ngSwitchCase="linkTypes.PROGRAMMATIC"
            draggable="false"
            class="card-container"
            (click)="linkAction($event, item)"
          >
            <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
          </a>
          <a
            *ngSwitchCase="linkTypes.EXTERNAL"
            draggable="false"
            class="card-container"
            [href]="item.link.url"
            [target]="item.link.target"
          >
            <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
          </a>
          <div *ngSwitchCase="linkTypes.NONE" class="card-container">
            <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
          </div>
          <div *ngSwitchCaseDefault class="card-container">
            <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #cardTemplate>
        <mb-card-hero
          [data]="item"
          alignContent="top"
          [sperateFooter]="true"
          fuelLabelPosition="bottom"
          (click)="openCardMedia(item)"
        >
          <figure *ngIf="item.media" media>
            <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
          </figure>

          <mb-action-container
            *ngIf="item.actions && item.actions.length"
            action-container
            [buttonItems]="item.actions"
            [resource]="item"
          ></mb-action-container>
        </mb-card-hero>
      </ng-template>
    </ng-template>
  </mb-slider-base>

  <ng-template #placeholdertpl>
    <div *ngIf="!shouldRender" class="placeholder-container container-sm">
      <div class="row">
        <div class="col col-{{ 12 / itemsToShow }}">
          <div class="placeholder-item" [style.aspect-ratio]="ratio"></div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
